import React from 'react';
import Typography from '@material-ui/core/Typography';

class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    // Update state so the next render will show the fallback UI.
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    const { logErrorToMyService } = this.props;
    // You can also log the error to an error reporting service
    if (logErrorToMyService) {
      logErrorToMyService(error, errorInfo);
    }
  }

  render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return (
        <Typography variant="caption" align="center" color="error">
          Something went wrong.
        </Typography>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
